const API_BASE_URL = process.env.BASE_URL

export const TESTIMONIALS_ENDPOINTS = {
    LIST: API_BASE_URL + "/api/public/testimonials/",
}
